<template>
  <div class="head">
    <Nav></Nav>
    <div id="header">
      <div class="w">
        <div class="search_logo">
          <a href="javascript:;" @click="goIndex()">
            <img class="sy_logo" :src="logoUrl" />
          </a>
        </div>
        <div class="search_box">
          <input type="text" placeholder="请输入您要搜索的信息" />
          <button class="search-button"></button>
        </div>
        <div class="search-design">
          <button>
            <img src="../../assets/index/nav_icon/logo-design.png" />
            <span>logo设计</span>
          </button>
        </div>
        <div class="search-shopCar">
          <i class="shop-icon"></i>
          <span>我的购物车</span>
        </div>

        <div class="navitems-group">
          <ul class="clearfix">
            <li v-for="(item,index) in headerList" class="m_item" :key="index">
              <a href="javascript:;" v-if="item.remark===''">{{item.title}}</a>
              <a
                v-else-if="item.remark.includes('http')"
                :href="item.remark"
                target="_blank"
              >{{item.title}}</a>
              <router-link v-else :to="item.remark">{{item.title}}</router-link>
            </li>
          </ul>
          <!-- <ul v-else class="clearfix">
            <li @click="goIndex()" class="m_item">
              <a href="javascript:;">首页</a>
            </li>
            <li class="m_item">
              <a href="javascript:;">新品抢购</a>
            </li>
            <li class="m_item">
              <a href="javascript:;">限时抢购</a>
            </li>
            <li class="m_item">
              <a href="javascript:;">作品中心</a>
            </li>
            <li class="m_item">
              <a href="javascript:;">产品中心</a>
            </li>
            <li class="m_item">
              <a href="javascript:;">预存有礼</a>
            </li>
            <li class="last-navitems m_item">
              <a href="javascript:;">
                一站式营销物料采购
                <img src="../../assets/index/nav_icon/arrow_down.png" />
              </a>
              <div class="drap_down">
                <ul>
                  <li class="drap_li_first">
                    <a href="javascript:;">
                      <span></span>
                      <i>展会必备</i>
                    </a>
                  </li>
                  <li class="drap_li_two">
                    <a href="javascript:;">
                      <span></span>
                      <i>日常办公</i>
                    </a>
                  </li>
                  <li class="drap_li_three">
                    <a href="javascript:;">
                      <span></span>
                      <i>培训套装</i>
                    </a>
                  </li>
                  <li class="drap_li_focu">
                    <a href="javascript:;">
                      <span></span>
                      <i>门店套装</i>
                    </a>
                  </li>
                  <li class="drap_li_five">
                    <a href="javascript:;">
                      <span></span>
                      <i>地推套装</i>
                    </a>
                  </li>
                  <li class="drap_li_six">
                    <a href="javascript:;">
                      <span></span>
                      <i>门店节日</i>
                    </a>
                  </li>
                  <li class="drap_li_event">
                    <a href="javascript:;">
                      <span></span>
                      <i>开业庆典</i>
                    </a>
                  </li>
                  <li class="drap_li_eight">
                    <a href="javascript:;">
                      <span></span>
                      <i>招聘套餐</i>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>-->
        </div>

        <div class="categories">
          <div class="cate-title">全部商品分类</div>
          <div class="y_cate">
            <ul class="catemenu">
              <template v-for="item in menuList">
                <div class="mProduct">
                  <li class="menuItem" :key="item.id">
                    <a
                      href="javascript:;"
                      :id="item2.id"
                      v-for="(item2,index2) in item"
                      :key="index2"
                    >{{item2.name}}&nbsp;&nbsp;</a>
                  </li>
                  <div class="hotBox">
                    <a
                      class="hot_product"
                      @click="godetail(item1.id,item1.type)"
                      href="javascript:void(0);"
                      v-for="item1 in item[0].list"
                      :key="item.id"
                    >{{item1.name}}</a>
                  </div>
                </div>
              </template>
              <div class="cate_pop one" style="display:none">
                <div class="cate_part">
                  <template v-for="(item1,index1) in mList">
                    <div class="clearfix" :key="index1">
                      <div class="cate_title">
                        <a href="javascript:;" :id="item1.id">{{item1.name}}</a>
                      </div>
                      <ul>
                        <li v-for="(item2,inde2) in item1.goods" :key="inde2">
                          <a
                            href="javascript:;"
                            :id="item2.product_id"
                            @click="godetail(item2.product_id,item2.type)"
                          >{{item2.product_name}}</a>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
                <div class="cate_img">
                  <div>
                    <img src="../../assets/index/01/xuanchuan01.png" alt />
                  </div>
                  <div class="two">
                    <img src="../../assets/index/01/xuanchuan02.png" alt />
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '../index/nav'

export default {
  components: {
    Nav
  },
  data() {
    return {
      flag: false,
      headerList: {},
      menuList: {},
      mList: {},
      nickname: '',
      avatar: '',
      logoUrl: ''
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    goregister() {
      this.$router.push('/register')
    },
    exit() {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('u')
      this.$router.push('/login')
    },
    goIndex() {
      this.$router.push('/index')
    },
    godetail(id, type) {
      if (type == '1') {
        window.location.href = '/index/user/product/product_id/' + id
        $('.y_cate').hide()
      } else {
        this.$router.push('/detail?id=' + id)
        $('.y_cate').hide()
      }
},
    // 获取header数据
    async queryList() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/page/nav',
        data: param
      })
      JSON.stringify(res.data) !== []
        ? (this.headerList = res.data)
        : (this.headerList = {})
    },

    async querymenuList() {
      const { data: res } = await this.$http.get('/api/page/menu')
      if (res.code == 1) {
        const result = res.data
        this.menuList = result
      }
    }
  },
  created() {
    const bool = window.localStorage.getItem('token')
    if (window.localStorage.getItem('u')) {
      const u = window.localStorage.getItem('u')
      this.nickname = JSON.parse(u).nickname
      this.avatar = JSON.parse(u).avatar
    }

    this.queryList()
    this.querymenuList()

    if (!bool) {
      return (this.flag = false)
    }
    this.flag = true
  },
  mounted() {
    let timer
    timer = setInterval(() => {
      if (window.sessionStorage.getItem('sy_info')) {
        let sy_info = window.sessionStorage.getItem('sy_info')
        this.logoUrl = JSON.parse(sy_info).logo
        clearInterval(timer)
      }
    }, 100)
    const that = this
    $('.search-shopCar').click(function() {
      $('#shopCart').click()
    })

    $('.last-navitems').hover(function() {
      $('.drap_down')
        .stop()
        .fadeToggle(200)
    })
    $('.y_cate .catemenu').mouseleave(function() {
      $('.cate_pop').hide()
    })
    let time
    $('.catemenu').on('mouseover', '.mProduct', function() {
      $('.cate_pop').show()
      let ids = []
      $(this)
        .children('.menuItem')
        .children('a')
        .each(function(i, e) {
          let id = $(this).attr('id')
          ids.push(id)
        })
      clearTimeout(time)
      time = setTimeout(async () => {
        var params = new URLSearchParams()
        params.append('ids', ids)
        const { data: res } = await that.$http.post('/api/page/smenu', params)
        if (res.code == 1) {
          that.mList = res.data
        } else {
          alert('没有数据')
        }
      }, 100)
    })
    $('.categories').on('mouseout', function(e) {
      $('.y_cate').hide()
    })

    $('.cate-title').mouseover(function() {
      $('.y_cate').show()
    })
    $('.categories').on('mouseout mouseover', '.y_cate', function(e) {
      if (e.type == 'mouseout') {
        $('.y_cate').hide()
      } else {
        $('.y_cate').show()
      }
    })
  }
}
</script>

<style lang="less" scoped>
.nav {
  height: 35px;
  background: #eef2f5;
  .w {
    div {
      display: inline-block;
    }
    .left {
      line-height: 35px;
      a {
        margin-left: 5px;
      }
      span {
        margin-left: 20px;
      }
    }
    .right {
      float: right;
      .item {
        line-height: 35px;
        li {
          position: relative;
          padding: 0 6px;
          float: left;
          margin-right: 20px;
          a {
            vertical-align: middle;
            margin-right: 3px;
          }
        }
      }
    }
    .drapdown {
      display: none;
      z-index: 999;
      position: absolute;
      top: 36px;
      left: 0;
      width: 150px;
      height: 80px;
      background-color: #fff;
      .dd-inner {
        background-color: #fff;
        width: 100%;
        li {
          background-color: #fff;
          box-sizing: border-box;
          padding: 5px 12px !important;
          height: 30px;
          width: 100%;
          line-height: 30px;
          font-size: 12px;
          color: #666666;
          cursor: pointer;
          span {
            color: #e83030;
          }
        }
        li:hover {
          background: #edfff6;
          color: #a77c5a;
        }
      }
    }
    .drapdown2 {
      display: none;
      position: absolute;
      top: 36px;
      left: 0;
      background: #fff;
      z-index: 999;
      .dd_inner2 {
        width: 76px;
        height: 110px;
        background: #fff;
        ul {
          li {
            box-sizing: border-box;
            padding-left: 10px;
            width: 76px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            color: #666;
            background: #fff;
            cursor: pointer;
          }
          li:hover {
            background: #edfff6;
            color: #a77c5a;
          }
        }
      }
    }
    .drapdown3 {
      display: none;
      position: absolute;
      top: 36px;
      left: 0;
      background: #fff;
      z-index: 999;
      .dd_inner {
        width: 76px;
        height: 85px;
        li {
          box-sizing: border-box;
          padding-left: 10px;
          width: 76px;
          height: 24px;
          line-height: 24px;
          cursor: pointer;
          font-size: 12px;
          color: #666;
        }
        li:hover {
          background: #edfff6;
          color: #a77c5a;
        }
      }
    }
  }
}
#header {
  height: 140px;
  width: 100%;
  background-color: #fff;
  padding-top: 25px;
  .w {
    position: relative;
    height: 100%;
    .search_box {
      position: absolute;
      left: 323px;
      top: 10px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border: 2px solid #a77c5a;
      width: 480px;
      height: 44px;
      padding: 10px 20px;
      margin-right: 10px;
      input {
        height: 100%;
        width: 85%;
        font-size: 14px;
      }
      .search-button {
        position: absolute;
        top: 0;
        right: 0;
        width: 15%;
        height: 40px;
        background: url('../../assets/index/nav_icon/search.png') no-repeat
          center #a77c5a;
      }
    }
    .search-design {
      position: absolute;
      top: 11px;
      right: 265px;
      width: 118px;
      height: 40px;
      border: 1px solid #a77c5a;
      button {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        color: #a77c5a;
        font-size: 16px;
        background-color: #fff;
        img {
          margin-right: 8px;
        }
      }
    }
    .search-shopCar {
      position: relative;
      position: absolute;
      display: flex;
      box-sizing: border-box;
      top: 11px;
      right: 78px;
      width: 148px;
      height: 40px;
      border: 1px solid #ddd;
      padding: 11px 18px;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      .shop-icon {
        width: 17px;
        height: 17px;
        background: url('../../assets/index/nav_icon/shop-cart.png');
        margin-right: 7px;
      }
      .shop-count {
        position: absolute;
        top: 5px;
        right: 15px;
        width: 22px;
        height: 16px;
        line-height: 16px;
        background-color: #e83030;
        color: #fff;
        border-radius: 8px;
        text-align: center;
        font-size: 12px;
      }
      .cartList {
        display: none;
        position: absolute;
        top: 40px;
        left: -161px;
        width: 306px;
        height: 55px;
        border: 1px solid #0eaf63;
        background: #edfff6;
        .empty_cart {
          margin-top: 9px;
          .cart_pop {
            width: 250px;
            height: 38px;
            line-height: 38px;
            margin: auto;
            color: #a77c5a;
            font-size: 12px;
            vertical-align: middle;
            .cart_img {
              width: 45px;
              height: 38px;
            }
            span {
              transform: translate(5px, -10px);
            }
          }
        }
      }
    }
    .search-shopCar:hover {
      border: 1px solid #a77c5a;
      // border-bottom: none;
    }
    .hotwords {
      position: absolute;
      top: 60px;
      left: 320px;
      a {
        font-size: 12px;
        color: #999;
        margin-right: 8px;
      }
      .hot {
        color: #a77c5a;
      }
    }
    .navitems-group {
      position: absolute;
      bottom: 0;
      left: 320px;
      ul {
        .m_item {
          float: left;
          padding: 0 15px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          a {
            color: #333;
            font-size: 16px;
          }
        }
        .last-navitems {
          width: 160px;
          position: relative;
        }
        li:hover a {
          color: #a77c5a;
        }
        .drap_down {
          display: none;
          z-index: 999;
          position: absolute;
          top: 40px;
          right: -22px;
          width: 190px;
          height: 265px;
          background: #fff;
          ul {
            width: 100%;
            li {
              width: 100%;
              height: 32px;
              line-height: 32px;
              a {
                font-size: 14px;
                color: #666;
                display: flex;
                align-items: center;
                justify-content: center;
                span {
                  display: inline-block;
                  width: 16px;
                  height: 14px;
                  margin-right: 8px;
                }
                img {
                  margin-right: 8px;
                }
              }
            }
            .drap_li_first {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/one.png')
                    no-repeat;
                }
              }
            }
            .drap_li_two {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/two.png')
                    no-repeat;
                }
              }
            }
            .drap_li_three {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/three.png')
                    no-repeat;
                }
              }
            }
            .drap_li_focu {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/focu.png')
                    no-repeat;
                }
              }
            }
            .drap_li_five {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/five.png')
                    no-repeat;
                }
              }
            }
            .drap_li_six {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/six.png')
                    no-repeat;
                }
              }
            }
            .drap_li_event {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/event.png')
                    no-repeat;
                }
              }
            }
            .drap_li_eight {
              a {
                span {
                  background: url('../../assets/icons/nav_icons/eight.png')
                    no-repeat;
                }
              }
            }
            .drap_li_first:hover a {
              span {
                background: url('../../assets/icons/nav_icons/one-curr.png')
                  no-repeat;
              }
            }
            .drap_li_two:hover a {
              span {
                background: url('../../assets/icons/nav_icons/two-curr.png')
                  no-repeat;
              }
            }
            .drap_li_three:hover a {
              span {
                background: url('../../assets/icons/nav_icons/three-curr.png')
                  no-repeat;
              }
            }
            .drap_li_focu:hover a {
              span {
                background: url('../../assets/icons/nav_icons/focu-curr.png')
                  no-repeat;
              }
            }
            .drap_li_five:hover a {
              span {
                background: url('../../assets/icons/nav_icons/five-curr.png')
                  no-repeat;
              }
            }
            .drap_li_six:hover a {
              span {
                background: url('../../assets/icons/nav_icons/six-curr.png')
                  no-repeat;
              }
            }
            .drap_li_event:hover a {
              span {
                background: url('../../assets/icons/nav_icons/event-curr.png')
                  no-repeat;
              }
            }
            .drap_li_eight:hover a {
              span {
                background: url('../../assets/icons/nav_icons/eight-curr.png')
                  no-repeat;
              }
            }
            li:hover {
              background-color: #edfff6;
            }
            li:hover a {
              color: #a77c5a;
            }
          }
          .drap_li_first {
            margin-top: 9px;
          }
        }
      }
    }

    .categories {
      z-index: 999;
      position: absolute;
      top: 98px;
      left: 0;
      width: 300px;
      height: 512px;
      color: #fff;
      .cate-title {
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 16px;
        background-color: #a77c5a;
      }
      .y_cate {
        position: relative;
        background-color: #000;
        height: 100%;
        display: none;
        .catemenu {
          .hotBox {
            padding: 0 17px;
            .hot_product {
              display: inline-block;
              width: 25%;
              color: #999;
            }
            .hot_product:hover {
              color: #a77c5a;
            }
          }
          .menuItem {
            padding: 0 12px;
            height: 30px;
            line-height: 30px;
            transition: 0.2s all;
            a {
              color: #fff;
              font-size: 16px;
            }
          }
          .menuItem:hover {
            box-sizing: border-box;
            background-color: #fff;
            border-left: 2px solid #0eaf63;
            a {
              color: #000;
            }
          }
          a:hover {
            color: #a77c5a;
          }
        }
        .cate_pop {
          position: absolute;
          top: 0;
          left: 300px;
          width: 999px;
          height: 468px;
          background-color: #fff;
          border: 1px solid #a77c5a;
          z-index: 999;
          .cate_img {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 192px;
            height: 100%;
            div {
              margin-bottom: 8px;
              img {
                width: 100%;
              }
            }
            .two {
              margin-top: 8px;
            }
          }
          .cate_part {
            display: flex;
            margin-bottom: 10px;
            div {
              margin-right: 10px;
              .cate_title {
                padding: 8px 12px;
                a {
                  font-size: 12px;
                  font-weight: bold;
                  color: #333;
                }
              }
              ul {
                float: left;
                margin-left: 12px;
              }
            }
          }
        }
      }
    }
  }
}
.sy_logo {
  width: 200px;
}
</style>
<style>
.el-breadcrumb {
  padding-top: 15px;
}
.el-breadcrumb__inner a:hover,
.el-breadcrumb__inner:hover {
  color: #0eaf63 !important;
  cursor: pointer;
}
</style>
